module.exports = __webpack_public_path__ + "img/delete.ec99e1cf.svg";